// 用户数据
export const users = [
  {
    id: 1,
    name: 'qmau',
    email: 'qmau@example.com',
    password: '123456',
    avatar: `${process.env.PUBLIC_URL}/qmau.jpg`,
    techStack: "React, JavaScript, Node.js",
    interests: "编程, 旅行, 摄影",
    intro: "热爱技术，喜欢分享",
    details: "欢迎来到我的博客！",
  }
];

// 文章数据
export const posts = [
  {
    id: "1766735622630",
    title: "武汉美食打卡全攻略：在烟火气里吃透江湖味",
    author: "qmau",
    date: "2025-12-26 15:53:42",
    tags: ["武汉", "美食", "攻略"],
    summary: "武汉的美食，从来都藏在市井烟火里。热干面的芝麻酱香飘满老巷，糊汤粉的鲜气裹着油条钻进鼻腔，小龙虾的麻辣在夏夜的排档里沸腾——这座被长江与汉水滋养的城市，连美食都带着江湖的豪爽与鲜活。无论是\"过早\"的匆忙惬意，还是正餐的酣畅淋漓，亦或是夜宵的热闹喧嚣，都值得你一一打卡。这份超全武汉美食攻略，带你从清晨吃到深夜，吃透武汉的专属味道。",
    content: "武汉的美食文化源远流长，从清晨的热干面到深夜的大排档，每一餐都充满了浓郁的地方特色。热干面是武汉最具代表性的早餐，面条劲道，芝麻酱浓郁，再配上酸豆角、萝卜丁等配菜，一碗下肚，回味无穷。\n\n糊汤粉则是另一种经典早餐，鱼汤熬制的粉条，口感鲜美，温暖身心。午餐时分，不妨试试武昌鱼、排骨藕汤等传统湖北菜，食材新鲜，口味醇厚。\n\n到了晚上，小龙虾、烧烤、鸭脖等夜宵更是让人欲罢不能。武汉人爱吃、会吃，这种对美食的执着追求，也体现了这座城市的生活态度。",
    excerpt: "武汉的美食，从来都藏在市井烟火里。热干面的芝麻酱香飘满老巷，糊汤粉的鲜气裹着油条钻进鼻腔...",
    readTime: "8 min read",
    views: 120,
    likes: 15
  },
  {
    id: "1766735622631",
    title: "React Hooks 完全指南",
    author: "qmau",
    date: "2025-12-27 10:30:15",
    tags: ["React", "前端", "JavaScript"],
    summary: "React Hooks 是 React 16.8 引入的新特性，它让你能够在不编写 class 的情况下使用 state 以及其他的 React 特性。",
    content: "React Hooks 是 React 16.8 引入的新特性，它让你能够在不编写 class 的情况下使用 state 以及其他的 React 特性。通过使用 Hooks，你可以将组件逻辑提取到可重用的函数中，而不是强制绑定到组件的生命周期中。\n\n常用的 Hooks 包括 useState、useEffect、useContext、useReducer、useCallback、useMemo 等。这些 Hooks 提供了丰富的功能，帮助开发者更好地管理组件状态和生命周期。\n\n例如，useState 允许你在函数组件中添加状态，useEffect 可以处理副作用，如数据获取、订阅或手动更改 DOM。",
    excerpt: "React Hooks 是 React 16.8 引入的新特性，它让你能够在不编写 class 的情况下使用 state 以及其他的 React 特性。",
    readTime: "12 min read",
    views: 240,
    likes: 28
  },
  {
    id: "1766735622632",
    title: "Ant Design 组件库使用技巧",
    author: "qmau",
    date: "2025-12-28 14:45:22",
    tags: ["React", "UI", "Ant Design"],
    summary: "Ant Design 是一个企业级 UI 设计语言和 React 组件库，本文将介绍一些使用技巧和最佳实践。",
    content: "Ant Design 是蚂蚁金服体验技术部推出的一个企业级 UI 设计语言和 React 组件库。它提供了丰富的组件，覆盖了大部分常见的业务场景。\n\n在使用 Ant Design 时，需要注意组件的定制化、国际化、主题定制等方面。通过合理的配置，可以快速构建出专业、美观的用户界面。\n\n此外，Ant Design 还提供了大量的设计资源和开发工具，帮助团队提高开发效率，保证产品的一致性和可用性。",
    excerpt: "Ant Design 是一个企业级 UI 设计语言和 React 组件库，本文将介绍一些使用技巧和最佳实践。",
    readTime: "10 min read",
    views: 180,
    likes: 22
  }
];

// 默认关于信息模板
export const defaultAboutInfoTemplate = {
  name: '未设置昵称',
  avatar: 'https://tu.tuhenmei.com/zb_users/upload/2023/06/202306131686617233591030.jpg',
  intro: '这个人很神秘，什么也没留下。',
  details: '欢迎来到我的博客！请登陆后完善您的个人信息！',
  email: '未设置邮箱', 
  techStack: '暂无',
  interests: '暂无',
  github: '#',
  linkedin: '#',
  personalHomepage: '#',
};

// 更新用户信息
export const updateUser = (userData) => {
  return new Promise((resolve, reject) => {
    try {
      // 获取当前用户信息
      const storedUsers = JSON.parse(localStorage.getItem('users')) || [];
      
      // 查找当前用户
      const userIndex = storedUsers.findIndex(user => user.id === userData.id);
      
      if (userIndex !== -1) {
        // 更新用户信息
        storedUsers[userIndex] = { ...storedUsers[userIndex], ...userData };
      } else {
        // 如果用户不存在，则添加新用户
        storedUsers.push(userData);
      }
      
      // 保存到localStorage
      localStorage.setItem('users', JSON.stringify(storedUsers));
      
      resolve(storedUsers[userIndex]);
    } catch (error) {
      reject(error);
    }
  });
};

// 根据ID获取用户信息
export const getUserById = (userId) => {
  return new Promise((resolve, reject) => {
    try {
      // 获取存储的用户信息
      const storedUsers = JSON.parse(localStorage.getItem('users')) || [];
      
      // 查找指定ID的用户
      const user = storedUsers.find(user => user.id === userId);
      
      if (user) {
        resolve(user);
      } else {
        // 如果在localStorage中找不到，尝试从默认用户中查找
        const defaultUser = users.find(u => u.id === userId);
        resolve(defaultUser || null);
      }
    } catch (error) {
      reject(error);
    }
  });
};

// 验证用户登录
export const validateUser = (username, password) => {
  return new Promise((resolve, reject) => {
    try {
      // 从localStorage获取用户数据
      const storedUsers = JSON.parse(localStorage.getItem('users')) || [];
      
      // 查找匹配的用户
      const user = storedUsers.find(u => u.name === username && u.password === password);
      
      if (user) {
        resolve(user);
      } else {
        // 检查默认用户（如qmau）
        const defaultUser = users.find(u => u.name === username && u.password === password);
        if (defaultUser) {
          resolve(defaultUser);
        } else {
          resolve(null); // 用户不存在或密码错误
        }
      }
    } catch (error) {
      reject(error);
    }
  });
};

// 注册新用户
export const registerUser = (userData) => {
  return new Promise((resolve, reject) => {
    try {
      // 从localStorage获取现有用户
      const storedUsers = JSON.parse(localStorage.getItem('users')) || [];
      
      // 检查用户名是否已存在
      const existingUser = storedUsers.find(u => u.name === userData.name);
      if (existingUser) {
        resolve({ success: false, message: '用户名已存在' });
        return;
      }
      
      // 为新用户生成ID
      const newUser = {
        id: Date.now(),
        ...userData,
        avatar: userData.name === 'qmau' ? `${process.env.PUBLIC_URL}/qmau.jpg` : null, // qmau用户使用特定头像
        techStack: userData.techStack || "暂无",
        interests: userData.interests || "暂无",
        intro: userData.intro || "这个人很神秘，什么也没留下。",
        details: userData.details || "欢迎来到我的博客！请登陆后完善您的个人信息！"
      };
      
      // 添加新用户到数组
      storedUsers.push(newUser);
      
      // 保存到localStorage
      localStorage.setItem('users', JSON.stringify(storedUsers));
      
      resolve({ success: true, user: newUser });
    } catch (error) {
      reject(error);
    }
  });
};
// 保存文章到本地存储
export const savePost = (post) => {
  return new Promise((resolve, reject) => {
    try {
      // 从localStorage获取现有文章
      let existingPosts = JSON.parse(localStorage.getItem('posts')) || [];
      
      // 检查是否是更新现有文章
      const existingIndex = existingPosts.findIndex(p => p.id === post.id);
      
      if (existingIndex !== -1) {
        // 更新现有文章
        existingPosts[existingIndex] = post;
      } else {
        // 添加新文章
        existingPosts.unshift(post);
      }
      
      // 保存到localStorage
      localStorage.setItem('posts', JSON.stringify(existingPosts));
      
      resolve(post);
    } catch (error) {
      reject(error);
    }
  });
};

// 删除文章
export const deletePost = (postId) => {
  return new Promise((resolve, reject) => {
    try {
      let existingPosts = JSON.parse(localStorage.getItem('posts')) || [];
      
      // 过滤掉要删除的文章
      existingPosts = existingPosts.filter(post => post.id !== postId);
      
      // 保存到localStorage
      localStorage.setItem('posts', JSON.stringify(existingPosts));
      
      // 记录已删除的文章ID，以便在 getAllPosts 中排除
      const deletedPosts = JSON.parse(localStorage.getItem('deletedPosts')) || [];
      if (!deletedPosts.includes(postId)) {
        deletedPosts.push(postId);
        localStorage.setItem('deletedPosts', JSON.stringify(deletedPosts));
      }
      
      resolve();
    } catch (error) {
      reject(error);
    }
  });
};

// 还原已删除的文章
export const restorePost = (postId) => {
  return new Promise((resolve, reject) => {
    try {
      // 从已删除列表中移除文章ID
      const deletedPosts = JSON.parse(localStorage.getItem('deletedPosts')) || [];
      const updatedDeletedPosts = deletedPosts.filter(id => id !== postId);
      localStorage.setItem('deletedPosts', JSON.stringify(updatedDeletedPosts));
      
      resolve();
    } catch (error) {
      reject(error);
    }
  });
};

// 获取已删除的文章
export const getDeletedPosts = () => {
  return new Promise((resolve, reject) => {
    try {
      const deletedPostIds = JSON.parse(localStorage.getItem('deletedPosts')) || [];
      
      // 获取所有文章（包括默认文章和存储的文章）
      const storedPosts = JSON.parse(localStorage.getItem('posts')) || [];
      const allPosts = [...storedPosts, ...posts]; // 合并默认文章和存储的文章
      
      // 找到已删除的文章
      const deletedPosts = allPosts.filter(post => deletedPostIds.includes(post.id));
      
      resolve(deletedPosts);
    } catch (error) {
      reject(error);
    }
  });
};

// 获取所有文章
export const getAllPosts = () => {
  const storedPosts = JSON.parse(localStorage.getItem('posts')) || [];
  const deletedPosts = JSON.parse(localStorage.getItem('deletedPosts')) || [];
  
  // 合并默认文章和存储的文章，避免重复，排除已删除的文章
  const allPostIds = new Set();
  const allPosts = [];
  
  // 首先添加存储的文章（未被删除的）
  storedPosts.forEach(post => {
    if (!deletedPosts.includes(post.id)) {
      allPosts.push(post);
      allPostIds.add(post.id);
    }
  });

  // 然后添加默认文章中不在存储中且未被删除的文章
  posts.forEach(post => {
    if (!allPostIds.has(post.id) && !deletedPosts.includes(post.id)) {
      allPosts.push(post);
    }
  });
  
  return allPosts;
};